<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6">
          Nomor KV Pelunasan BL
        </v-card-title>

        <v-container>
          <v-text-field
            v-model="formData.kv"
            label="Nomor KV"
            outlined
            hide-details
            @keydown.enter="checkNomorPelunasan"
            :disabled="loading"
            :loading="loading"
            autofocus
          ></v-text-field>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "FindNomoPelunasanBL",
  props: ["openModal"],
  data() {
    return {
      formData: {
        kv: ""
      },
      loading: false
    };
  },
  watch: {
    openModal(val) {
      if (val) {
        this.formData.kv = "";
      }
    },
    "formData.kv"(val) {
      if (val) {
        this.formData.kv = val.toUpperCase();
      }
    }
  },
  methods: {
    async checkNomorPelunasan() {
      this.loading = true;

      await axios
        .post(`pelunasan-bl/info-pelunasan`, this.formData)
        .then(res => {
          this.loading = false;

          this.$emit("close-modal", res.data);
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    }
  }
};
</script>
